import { Environment } from './types'

export const productionEnvironment: Environment = {
	// API
	API_URL: 'https://api.brandtrack.fm',
	API_TIMEOUT: 60000,
	FIXED_API_URL: '',

	// App
	APP_NAME: 'MyBrandTrack',
	APP_VERSION: '3.0.0',
	COMPANY_NAME: 'Brandtrack',

	// Features
	ENABLE_POSTHOG: 'all',
	ENABLE_AMPLITUDE: 'all',

	// Other
	NODE_ENV: 'production',

	// Build type
	BUILD_TYPE: 'brandtrack',
}
